var $ec7bd5a9ca7a533e$exports = {};
$ec7bd5a9ca7a533e$exports = {
    "collapse": `Contraer`,
    "columnResizer": `Redimensionador de columnas`,
    "drag": `Arrastrar`,
    "expand": `Ampliar`,
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`,
    "resizeColumn": `Cambiar el tama\xf1o de la columna`,
    "sortAscending": `Orden ascendente`,
    "sortDescending": `Orden descendente`
};


export {$ec7bd5a9ca7a533e$exports as default};
//# sourceMappingURL=es-ES.mjs.map
